import React from 'react';
import SST_industria from 'img/SST_industria_mineria.png';
import HelpContent from './HelpContent';

/*
 * Ayuda para Introducción Energías Renovables 
 */

const IntroERHelp = () => (
  <HelpContent>
    <h1>Energía solar en procesos térmicos de la industria</h1>
    <p>
      Esta medida tiene como objetivo la reducción de emisiones de GEI aprovechando el uso de
      energías renovables no convencionales en procesos productivos. En particular, se considera
      el uso de Sistemas Solares Térmicos (SST) como fuente de calor en procesos térmicos de baja
      temperatura de la industria y minería.
    </p>
    <img src={SST_industria} alt="Sistema Solar Térmico" />
    <label>Figura: Sistema Solar Térmico</label>
  
    <p>
    <strong>Trayectoria 1:</strong>  En los sectores de industrias y minas varias, papel y celulosa, cemento, azúcar y siderurgia, los SST cubren el 7,3% de la demanda térmica en 2035, el 9,3% en 2040 y el 13,1% en 2050.
    </p>
    <p>
    <strong>Trayectoria 2:</strong> En los sectores de industrias y minas varias, papel y celulosa, cemento, azúcar y siderurgia, los SST alcanzan a cubrir el 7,3% de la demanda térmica en 2035, el 9,3% en 2040 y el 26,2% en 2050.
    </p>
  </HelpContent>
);

export default IntroERHelp;
